export const routesWithoutSidebar = ['Photo', 'Keycard', 'KeycardNew', 'KeycardSelect']
export const routesWithoutDesktopNavigation = ['Resorts']
export const routesWithoutMobileNavigation = ['Results']
export const routesThatResetState = ['Resorts', 'Catalog', 'Steps']
export const routesWithWhiteBackground = ['Results']